<ups-top-banner-broadcast *ngIf="message | async as msg" [broadcastMessage]="msg.body"></ups-top-banner-broadcast>
<!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
<router-outlet *ngIf="!isIframe"></router-outlet>

<ups-spinner></ups-spinner>
<ups-toast></ups-toast>
